import React, { Component } from 'react';
import numeral from 'numeral';
import classNames from 'classnames';

import CartItem from './CartPage/CartItem';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import { Link } from 'react-router-dom';
import Layout from '../../ui/Layout';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import CookieLink from '../../ui/CookieLink';
import MetaLoader from '../../ui/MetaLoader';

const REACT_APP_CHECKOUT_LINK = `${process.env.REACT_APP_CHECKOUT_LINK}`;

const formatMoney = (p, noItems) =>
  numeral(noItems ? 0 : p || 0).format('$0,0.00');

class CartPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getCart();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart',
      'page-template-page-templatesshop-template-cart-php',
      'page',
      'page-id-227',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart',
      'page-template-page-templatesshop-template-cart-php',
      'page',
      'page-id-227',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);
    const {
      cart,
      deleteCartItem,
      userInProgress,
      inProgress,
      user
    } = this.props;

    const {
      shoppingCartItems,
      totals
    } = cart || {};

    const {
      freight,
      subTotal,
      tax,
      totalAmountDue,
      totalMarkdown
    } = totals || {};

    const { userId } = user || {};

    const hasUser = !!userId;

    const handleRemoveItem = shoppingCartItemId =>
      deleteCartItem(shoppingCartItemId);

    const noItems = (shoppingCartItems || []).length === 0;

    const numItems = (shoppingCartItems || [])
      .reduce((prev, { qty }) => prev + qty, 0);

    return (
      <Layout>
        <MetaLoader title="Cart | Twomey" />
        <MetaTags>
          <title>Cart | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Cart | Twomey" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content="https://twomey.com/shop/cart" />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main shop-page nohero cart-page">

              {inProgress && <Loading fullPage scrollToTop />}
              {!inProgress &&
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="cart-items">
                        <h1 className="h3-style column-header">
                          Your Cart
                          {' '}
                          <span>({numItems} Total)</span>
                        </h1>

                        {(shoppingCartItems || [])
                          .map((item, index) => (
                            <CartItem
                              key={index}
                              {...item}
                              handleRemoveItem={handleRemoveItem}
                            />
                          ))}
                        {noItems &&
                          <div
                            style={{
                              textAlign: 'center',
                              fontSize: '30px',
                              padding: '40px 0'
                            }}
                          >
                            There are no items in your cart
                          </div>}

                      </div>
                    </div>
                    <div className="col-lg-4">

                      <div className="cart-summary">
                        <div className="summary-top">
                          <div className="row">
                            <div className="col">
                              <h3>Summary</h3>
                            </div>
                            <div className="col d-sm-block d-lg-none">
                              <h3 className="text-right">
                                <a
                                  href="#"
                                  className="expand-mobile-cart"
                                  aria-label="toggle cart"
                                >
                                  <i
                                    className="fas fa-chevron-down this-closed"
                                  />
                                  <i className="fas fa-times this-open" />
                                </a>
                              </h3>
                            </div>
                          </div>
                          <table width="100%" className="summary">
                            <tbody>
                              <tr>
                                <td>Subtotal:</td>
                                <td className="text-right">
                                  {formatMoney(subTotal, noItems)} USD
                                </td>
                              </tr>
                              <tr>
                                <td>Estimated Shipping:</td>
                                <td className="text-right">
                                  {formatMoney(freight, noItems)} USD
                                </td>
                              </tr>
                              <tr>
                                <td>Estimated Tax:</td>
                                <td className="text-right">
                                  {formatMoney(tax, noItems)} USD
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="summary-bottom">
                          <table width="100%" className="total">
                            <tbody>
                              <tr>
                                <td>TOTAL:</td>
                                <td className="text-right">
                                  {formatMoney(totalAmountDue, noItems)} USD
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="cart-summary-button">
                        {hasUser &&
                          <CookieLink
                            id="tag-button-cart"
                            href={`${REACT_APP_CHECKOUT_LINK}/shipping/`}
                            label="Checkout"
                            className={classNames(
                              'btn btn-primary btn-block',
                              noItems || userInProgress || inProgress
                                ? 'disabled'
                                : ''
                            )}
                          />}
                        {!hasUser &&
                          <Link
                            to="/shop/login/"
                            id="tag-button-cart"
                            className={classNames(
                              'btn btn-primary btn-block',
                              noItems || userInProgress || inProgress
                                ? 'disabled'
                                : ''
                            )}
                          >
                            Continue
                          </Link>}
                      </div>

                      <div className="cart-contact">
                        <h4>HAVE QUESTIONS?</h4>
                        <p>We’re here to help Mon-Fri 8am to 5pm PT</p>
                        <p>
                          Call (888) 202 2006 or
                          {' '}
                          <a href="mailto:customercare@twomey.com">email us</a>
                        </p>
                      </div>

                    </div>

                  </div>
                </div>}

            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error,
    inProgress,
    result: cart
  } = state.getCart.toJS();

  const {
    inProgress: validateInProgress
  } = state.validateLogin.toJS();

  const {
    result: user,
    inProgress: postLoginInProgress
  } = state.postLogin.toJS();

  const userInProgress = validateInProgress || postLoginInProgress;
  return {
    user,
    cart,
    userInProgress,
    inProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      deleteCartItem: fetchDux.deleteCartItem.createAction,
      getCart: fetchDux.getCart.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(CartPage);
